<template>
    <aurora-layout>
        <div class="steps my-10">
            <div class="steps-title flex justify-around w-350 md:w-670 mx-auto">
                <p class="text-white">Authorized lender</p>
                <p class="text-white mr-5">Bank account</p>
            </div>
            <div class="step-progress flex justify-around my-5">
                <StepProgress :step="2" />
            </div>
            <AppBoxContent v-if="!showBanking && !loading">
                <div class="inside-container-1 w-full sm:w-317 mx-auto">
                    <h2 class="text-center text-2xl md:text-4xl">Verify Bank Account</h2>
                    <p class="text-center my-4">
                        Once your account is verified and approved, you will get funded within 24 hours.
                    </p>
                </div>

                <div class="inside-container-2 w-full sm:w-450 mx-auto">
                    <div class="inner-container">
                        <div class="desired-loan">
                            <h3 class="font-semibold text-base py-4">Your desired loan amount</h3>
                            <div class="flex justify-between font-semi-bold text-primary text-4xl md:text-7xl">
                                <div class="value">{{ loan.amount | money(0) }}</div>
                                <div class="currance">USD</div>
                            </div>
                        </div>
                    </div>

                    <AppDivider />

                    <BoxAction
                        @click="handlePlaid()"
                        text="Click here to securely verify your bank account"
                        label="Instant connection"
                        badge="Fast way"
                    />

                    <AppDivider apparance="or" />

                    <ManualBankingWarning class="mb-4" />

                    <BoxAction
                        data-testid="manual"
                        text="Requires bank statements"
                        label="Manual"
                        appareance="white"
                        @click="handleManual"
                    />
                </div>
            </AppBoxContent>

            <AppBoxContent v-if="loading" class="flex flex-col">
                <div class="inside-container-1 flex flex-col w-full sm:w-317 mx-auto">
                    <h2 class="text-center text-2xl md:text-4xl">Verifying Bank Account</h2>
                    <p class="text-center my-4">
                        Please wait while we verify your bank account.
                    </p>
                </div>

                <div v-if="proceeding" class="flex flex-grow justify-center items-center">
                    <WaitingProgressBar :show-progress="proceeding" />
                    <!-- <i class="fa fa-circle-notch fa-spin text-3xl"/> -->
                </div>
            </AppBoxContent>

            <AppBankManualModal 
                :showModal="showManual" 
                :gPageName="gTagPageName" 
                :gEventType="gEventType"
                :loan="loan" 
                @close="handleCloseManual" 
                @proceed="proceed" />
        </div>
        
        <AppErrorPopup 
            :show="showErrorPopup" 
            :message="errorMessage" 
            @close="closeErrorPopup" 
        />
    </aurora-layout>
</template>

<script>
import StepProgress from "../../../components/AuroraStepProgress";
import AppBoxContent from "./../../../../../components/AppBoxContent";
import BoxAction from "../../../components/AuroraBoxAction.vue";
import AppDivider from "../../../../../components/AppDivider.vue";
import AppBankManualModal from "../../../../../components/AppBankManualModal.vue";
import WaitingProgressBar from "./../../../../../components/WaitingProgressBar.vue";
import AppErrorPopup from "../../../../../components/AppErrorPopup.vue";
import ManualBankingWarning from "../../../../../components/ManualBankingWarning.vue";

export default {
    mixins: [
        require("../../../../../mixins/InteractsWithGtag").default,
        require("../../../../../mixins/VerifyMethods").default,
        require("../../../../../mixins/PageViewAnalytics").default,
    ],

    components: {
        StepProgress,
        AppBoxContent,
        BoxAction,
        AppDivider,
        AppBankManualModal,
        WaitingProgressBar,
        AppErrorPopup,
        ManualBankingWarning
    },

    props: {
        user: {},
        loan: {},
        manual: {
            type: Boolean,
            default: false,
        },
        mxWidgetUrl: {},
        plaidLinkToken: {},
    },

    data() {
        return {
            gTagPageName: "VERIFY_ACCOUNT",
            gEventType: 'MarketPlaceSignUp',
            showBanking: false,
            showManual: false,
            mx: null,
            plaid: null,
            institution_id: null,
            institution_code: null,
            loading: false,
            proceeding: false,
            // for plaid asset / edge process
            attempts: 0,
            interval: null,
            maxAttempts: 12,
            // error popup state
            showErrorPopup: false,
            errorMessage: ''
        };
    },
  
    beforeDestroy() {
      if (this.interval) clearInterval(this.interval);
    },
};
</script>
